import { render, staticRenderFns } from "./SlipBody.vue?vue&type=template&id=47521800&scoped=true"
import script from "./SlipBody.vue?vue&type=script&lang=js"
export * from "./SlipBody.vue?vue&type=script&lang=js"
import style0 from "./SlipBody.vue?vue&type=style&index=0&id=47521800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47521800",
  null
  
)

export default component.exports